import React from 'react'

import { InputDropdown } from '@caudena/core/ui-kit'
import { SurfaceContainer } from '@caudena/core/ui-kit'
import { RadioMenu } from '@caudena/core/ui-kit'

interface TransferDirectionInputProps {
  value: string | null
  onChange: (value: string | null) => void
}

const options = [
  {
    label: 'In',
    value: 'in',
  },
  {
    label: 'Out',
    value: 'out',
  },
  {
    label: 'Both (In / Out)',
    value: 'both',
  },
]

const TransferDirectionInput = ({
  value,
  onChange,
}: TransferDirectionInputProps) => {
  const handleInputClear = () => {
    onChange(null)
  }

  const inputDropdownValue = value
    ? options.find((o) => o.value === value)?.label || ''
    : ''

  return (
    <InputDropdown
      clearable
      padded={false}
      variant="outline"
      startAddon={{ label: 'Transfer direction:' }}
      placeholder="Any"
      value={inputDropdownValue}
      onClear={handleInputClear}
      sameWidth
    >
      <SurfaceContainer spaces={'md'}>
        <RadioMenu
          value={value ?? undefined}
          options={options}
          onChange={onChange}
        />
      </SurfaceContainer>
    </InputDropdown>
  )
}

export default TransferDirectionInput
